var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCategoryPizza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_465_7322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.375 28.7947C66.375 28.7947 20.8059 56.6735 3.95769 132.438C2.70387 138.076 9.14946 142.24 13.765 138.768C33.965 123.575 76.9074 96.4411 136.326 86.6873C143.099 85.5756 146.518 77.9338 142.834 72.1429C133.859 58.0353 112.842 36.3176 66.375 28.7947Z",
    fill: "url(#paint0_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.723 71.9708C77.4351 79.9061 30.2995 109.522 8.838 125.664C7.708 126.514 6.46859 126.905 5.25918 126.931C4.80947 128.743 4.37124 130.576 3.95535 132.447C2.70271 138.081 9.15212 142.238 13.7651 138.768C33.9686 123.572 76.9227 96.4314 136.358 86.6823C143.091 85.5779 146.524 77.9564 142.867 72.1964C142.819 72.1214 142.771 72.0461 142.723 71.9708Z",
    fill: "url(#paint1_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.23 77.5877C145.23 77.5877 133.362 34.9838 62.3425 25.1379C62.3425 25.1379 16.9828 52.6294 0.641002 125.57C-0.575469 131 5.89306 134.877 10.4854 131.469C12.2387 130.169 14.1642 128.778 16.2587 127.316C18.8804 125.485 22.4801 127.364 22.4801 130.561V130.789C22.4801 134.169 25.2204 136.91 28.601 136.91C31.9816 136.91 34.7219 134.169 34.7219 130.789V124.377C34.7219 118.809 37.7604 113.686 42.6492 111.021C54.6139 104.499 68.7854 97.8521 84.9445 92.0853C87.5204 91.1662 90.2322 93.0788 90.2322 95.8141C90.2322 99.1947 92.9725 101.935 96.3531 101.935C99.7337 101.935 102.474 99.1947 102.474 95.8141V87.9359C102.474 87.0497 103.063 86.2718 103.916 86.0318L103.956 86.0206C105.225 85.6635 106.484 86.6174 106.484 87.9353V107.881C106.484 111.261 109.224 114.001 112.605 114.001C115.985 114.001 118.726 111.261 118.726 107.881V90.8588C118.726 85.8106 122.291 81.4485 127.247 80.4868C133.076 79.3559 139.072 78.38 145.23 77.5877Z",
    fill: "url(#paint2_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3426 25.1382C62.3426 25.1382 53.6817 30.3879 42.5658 42.3841L100.494 100.313C101.709 99.1941 102.474 97.5955 102.474 95.8144V87.9361C102.474 87.0499 103.064 86.272 103.917 86.032L103.957 86.0208C105.226 85.6638 106.484 86.6176 106.484 87.9355V106.303L114.014 113.832C116.714 113.195 118.726 110.776 118.726 107.881V90.8588C118.726 85.8105 122.291 81.4485 127.247 80.4867C133.076 79.3555 139.072 78.3797 145.23 77.5876C145.23 77.5876 133.362 34.9838 62.3426 25.1382Z",
    fill: "url(#paint3_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1451 39.4402C76.5446 38.7599 75.8475 38.1134 75.0516 37.5131C68.5616 32.619 58.039 32.619 51.549 37.5131C45.3966 42.1525 45.0807 49.5228 50.5928 54.4467L97.881 101.735C100.521 101.055 102.474 98.6658 102.474 95.814V87.9358C102.474 87.0496 103.063 86.2717 103.916 86.0317L103.956 86.0205C105.225 85.6634 106.484 86.6173 106.484 87.9352V107.88C106.484 109.345 107 110.688 107.857 111.741C108.274 112.173 108.734 112.589 109.234 112.988C110.201 113.627 111.359 114.002 112.605 114.002C115.985 114.002 118.725 111.261 118.725 107.881V90.8587C118.725 88.1549 119.749 85.6487 121.46 83.7555L77.1451 39.4402Z",
    fill: "url(#paint4_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2452 59.1101C51.9946 56.508 47.9296 54.7704 43.2884 54.7704C36.2069 54.7704 30.4661 58.8151 30.4661 63.8048C30.4661 65.9345 31.5146 67.8907 33.2643 69.4351L64.1437 100.412C70.6534 97.5174 77.5908 94.7098 84.9446 92.0854C85.6202 91.8442 86.304 91.8022 86.947 91.9145L54.2452 59.1101Z",
    fill: "url(#paint5_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.822 66.447C104.543 63.9412 100.559 62.2788 96.0211 62.2788C88.9397 62.2788 83.1988 66.3235 83.1988 71.3132C83.1988 71.517 83.2117 71.7185 83.2305 71.9188C77.697 68.9923 70.0135 69.3903 65.0697 73.1185C59.8649 77.0435 59.5511 83.2591 64.1267 87.4612L73.2188 96.5532C77.0011 95.0197 80.9108 93.5253 84.9444 92.0859C87.5203 91.1668 90.232 93.0794 90.232 95.8147C90.232 99.1953 92.9723 101.936 96.3529 101.936C99.7335 101.936 102.474 99.1953 102.474 95.8147V87.9365C102.474 87.0503 103.063 86.2723 103.916 86.0323L103.956 86.0212C105.225 85.6641 106.484 86.6179 106.484 87.9359V107.881C106.484 111.262 109.224 114.002 112.605 114.002C115.985 114.002 118.726 111.262 118.726 107.881V90.8588C118.726 87.4879 120.317 84.4247 122.848 82.4738L106.822 66.447Z",
    fill: "url(#paint6_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2484 100.812L52.7287 90.2921C50.4499 87.7859 46.4655 86.1233 41.9272 86.1233C36.3722 86.1233 31.6434 88.6127 29.8625 92.0942C24.6731 90.3898 18.4087 91.1351 14.1643 94.3359C8.95929 98.2609 8.64576 104.477 13.2216 108.679L34.7219 130.179V124.377C34.7219 118.809 37.7605 113.686 42.6493 111.022C48.9181 107.604 55.799 104.153 63.2484 100.812Z",
    fill: "url(#paint7_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2497 75.255C29.5318 74.7232 29.3294 74.0635 28.798 73.7815C28.2662 73.4994 27.6065 73.7018 27.3244 74.2332C27.0424 74.765 27.2447 75.4247 27.7762 75.7068C28.3077 75.9891 28.9674 75.7868 29.2497 75.255Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6718 75.6942C25.2521 75.4716 24.7312 75.6313 24.5086 76.051C24.286 76.4707 24.4457 76.9916 24.8654 77.2142C25.2851 77.4369 25.806 77.2772 26.0286 76.8575C26.2512 76.4375 26.0915 75.9169 25.6718 75.6942Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6172 80.1799C26.3643 80.0458 26.0502 80.142 25.9161 80.3949C25.7819 80.6479 25.8781 80.962 26.1311 81.0961C26.384 81.2305 26.6981 81.134 26.8322 80.8811C26.9667 80.6282 26.8705 80.3143 26.6172 80.1799Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0553 81.6125C33.4535 81.5954 32.9521 82.0696 32.9353 82.671C32.9182 83.2728 33.3923 83.7743 33.9938 83.791C34.5956 83.8081 35.0971 83.334 35.1138 82.7325C35.1309 82.1307 34.6571 81.6293 34.0553 81.6125Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7255 73.9034C39.2505 73.8899 38.8547 74.2643 38.8414 74.739C38.8279 75.214 39.2023 75.6099 39.677 75.6234C40.152 75.637 40.5479 75.2626 40.5614 74.7876C40.5746 74.3126 40.2005 73.9167 39.7255 73.9034Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7323 74.2303C31.4458 74.2224 31.2073 74.448 31.1991 74.7341C31.1911 75.0206 31.4167 75.2591 31.7029 75.2674C31.9894 75.2753 32.2279 75.0497 32.2361 74.7635C32.2444 74.4771 32.0188 74.2385 31.7323 74.2303Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0212 78.6985C29.5877 78.7974 29.3162 79.2288 29.4148 79.6627C29.5136 80.0962 29.9451 80.3677 30.3789 80.2691C30.8124 80.1703 31.0839 79.7388 30.9853 79.305C30.8862 78.8715 30.4548 78.6 30.0212 78.6985Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9225 76.4501C30.5801 76.528 30.3657 76.8689 30.4437 77.2113C30.5216 77.5536 30.8625 77.768 31.2048 77.6901C31.5472 77.6121 31.7616 77.2713 31.6837 76.9289C31.6054 76.5865 31.2648 76.3721 30.9225 76.4501Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3383 77.694C28.5448 77.647 28.6739 77.4417 28.6269 77.2352C28.5798 77.0288 28.3745 76.8996 28.1681 76.9467C27.9616 76.9937 27.8325 77.199 27.8795 77.4055C27.9266 77.612 28.1319 77.7411 28.3383 77.694Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4539 72.0358C49.736 71.504 49.5336 70.8443 49.0021 70.5622C48.4704 70.2802 47.8107 70.4825 47.5286 71.014C47.2466 71.5458 47.4489 72.2055 47.9804 72.4875C48.5121 72.7696 49.1718 72.5672 49.4539 72.0358Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1779 81.4081C43.7582 81.1855 43.2373 81.3452 43.0146 81.7649C42.792 82.1846 42.9517 82.7055 43.3714 82.9281C43.7911 83.1508 44.312 82.9911 44.5346 82.5713C44.7573 82.1516 44.5976 81.6308 44.1779 81.4081Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.817 76.6747C42.5641 76.5403 42.2499 76.6367 42.1158 76.8897C41.9817 77.1426 42.0779 77.4567 42.3308 77.5909C42.5838 77.7253 42.8979 77.6288 43.032 77.3759C43.1661 77.1229 43.0699 76.8091 42.817 76.6747Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3892 73.5061C54.7874 73.489 54.2859 73.9631 54.2692 74.5646C54.2521 75.1664 54.7262 75.6678 55.3277 75.6846C55.9294 75.7016 56.4309 75.2275 56.4477 74.6261C56.4647 74.0246 55.9909 73.5231 55.3892 73.5061Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.269 72.0512C55.2826 71.5762 54.9081 71.1803 54.4331 71.1671C53.9581 71.1539 53.5623 71.528 53.549 72.0027C53.5355 72.4777 53.9099 72.8736 54.3846 72.8871C54.8596 72.9003 55.2555 72.5262 55.269 72.0512Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9368 71.0107C51.6503 71.0028 51.4118 71.2281 51.4036 71.5145C51.3956 71.801 51.6212 72.0395 51.9074 72.0478C52.1938 72.0557 52.4324 71.8301 52.4406 71.5439C52.4486 71.2575 52.223 71.0189 51.9368 71.0107Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.237 78.539C46.8035 78.6378 46.532 79.0693 46.6306 79.5031C46.7294 79.9366 47.1608 80.2081 47.5947 80.1096C48.0282 80.0107 48.2997 79.5793 48.2011 79.1455C48.1023 78.7116 47.6708 78.4402 47.237 78.539Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1267 73.2307C50.7843 73.3087 50.5699 73.6495 50.6478 73.9916C50.7258 74.334 51.0667 74.5484 51.4087 74.4704C51.7511 74.3925 51.9655 74.0516 51.8875 73.7095C51.8099 73.3672 51.469 73.1528 51.1267 73.2307Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5421 74.4748C48.7486 74.4277 48.8777 74.2225 48.8307 74.016C48.7836 73.8095 48.5783 73.6804 48.3718 73.7275C48.1654 73.7745 48.0363 73.9798 48.0833 74.1863C48.1301 74.3925 48.3357 74.5219 48.5421 74.4748Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7532 89.5206C61.0352 88.9889 60.8329 88.3292 60.3014 88.0471C59.7696 87.765 59.1099 87.9674 58.8279 88.4989C58.5458 89.0306 58.7482 89.6903 59.2796 89.9724C59.8114 90.2548 60.4711 90.0524 60.7532 89.5206Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1753 89.96C56.7555 89.7373 56.2347 89.897 56.012 90.3167C55.7894 90.7365 55.9491 91.2573 56.3688 91.48C56.7885 91.7026 57.3094 91.5429 57.532 91.1232C57.755 90.7032 57.595 90.1826 57.1753 89.96Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.121 94.4455C57.868 94.3114 57.5539 94.4076 57.4198 94.6606C57.2857 94.9135 57.3818 95.2276 57.6348 95.3617C57.8877 95.4958 58.2018 95.3997 58.336 95.1467C58.4701 94.8938 58.3739 94.58 58.121 94.4455Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.559 95.8781C64.9573 95.8611 64.4558 96.3352 64.439 96.9367C64.422 97.5384 64.8961 98.0399 65.4976 98.0567C66.0993 98.0737 66.6008 97.5996 66.6176 96.9981C66.6343 96.3967 66.1605 95.8949 65.559 95.8781Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.29 71.3132C114.087 70.8838 113.574 70.7006 113.144 70.9038C112.715 71.1071 112.531 71.6203 112.735 72.0497C112.938 72.4791 113.451 72.6624 113.881 72.4591C114.31 72.2559 114.494 71.7427 114.29 71.3132Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.236 88.4959C62.9495 88.488 62.711 88.7136 62.7028 88.9998C62.6948 89.2862 62.9204 89.5248 63.2066 89.533C63.4931 89.5409 63.7316 89.3153 63.7398 89.0292C63.7478 88.7427 63.5222 88.5042 63.236 88.4959Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5246 92.9641C61.0911 93.0629 60.8196 93.4943 60.9181 93.9282C61.017 94.3617 61.4484 94.6332 61.8823 94.5346C62.3158 94.4358 62.5873 94.0044 62.4887 93.5705C62.3902 93.1367 61.9581 92.8655 61.5246 92.9641Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4259 90.7159C62.0835 90.7939 61.8691 91.1348 61.9471 91.4771C62.025 91.8195 62.3659 92.0339 62.7079 91.9559C63.0503 91.878 63.2647 91.5371 63.1868 91.1948C63.1088 90.8524 62.7682 90.638 62.4259 90.7159Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8417 91.9597C60.0482 91.9126 60.1773 91.7073 60.1303 91.5008C60.0832 91.2944 59.8779 91.1653 59.6714 91.2123C59.465 91.2594 59.3358 91.4647 59.3829 91.6711C59.43 91.8776 59.6356 92.0067 59.8417 91.9597Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8295 41.9779C61.1116 41.4461 60.9092 40.7864 60.3777 40.5044C59.846 40.2223 59.1863 40.4247 58.9042 40.9561C58.6222 41.4879 58.8245 42.1476 59.356 42.4297C59.8877 42.712 60.5474 42.5097 60.8295 41.9779Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.619 78.6842C109.627 78.2092 109.249 77.8174 108.774 77.8092C108.299 77.801 107.907 78.1795 107.899 78.6545C107.89 79.1295 108.269 79.5213 108.744 79.5295C109.219 79.5377 109.611 79.1595 109.619 78.6842Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.221 75.3252C113.226 75.0387 112.998 74.8026 112.711 74.7976C112.425 74.7926 112.189 75.0208 112.184 75.3073C112.179 75.5937 112.407 75.8299 112.694 75.8349C112.98 75.8399 113.216 75.6117 113.221 75.3252Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7654 43.4482C66.1637 43.4311 65.6622 43.9053 65.6454 44.5067C65.6284 45.1085 66.1025 45.61 66.704 45.6267C67.3057 45.6438 67.8072 45.1697 67.824 44.5682C67.841 43.9667 67.3669 43.4653 66.7654 43.4482Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6446 41.9936C66.6581 41.5186 66.2837 41.1227 65.8087 41.1095C65.3337 41.096 64.9378 41.4704 64.9246 41.9451C64.9111 42.4201 65.2855 42.816 65.7602 42.8295C66.2352 42.8427 66.6311 42.4686 66.6446 41.9936Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3121 40.9532C63.0256 40.9453 62.7871 41.1706 62.7788 41.457C62.7709 41.7435 62.9965 41.982 63.2827 41.9903C63.5691 41.9982 63.8076 41.7726 63.8159 41.4864C63.8241 41.2 63.5985 40.9611 63.3121 40.9532Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.563 80.1105C113.278 79.7687 112.77 79.7225 112.429 80.007C112.087 80.2917 112.041 80.7993 112.325 81.1411C112.61 81.4828 113.117 81.529 113.459 81.2446C113.801 80.9599 113.847 80.4523 113.563 80.1105Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5022 43.1731C62.1599 43.2511 61.9455 43.5919 62.0234 43.934C62.1014 44.2764 62.4422 44.4908 62.7846 44.4128C63.1269 44.3349 63.3413 43.994 63.2634 43.6519C63.1852 43.3093 62.8446 43.0952 62.5022 43.1731Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9174 44.4169C60.1239 44.3699 60.253 44.1646 60.2059 43.9581C60.1589 43.7516 59.9536 43.6225 59.7471 43.6696C59.5406 43.7166 59.4115 43.9219 59.4586 44.1284C59.5056 44.3349 59.7109 44.464 59.9174 44.4169Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5632 64.5609C90.2435 65.0709 90.3976 65.7435 90.9076 66.0632C91.4176 66.383 92.0903 66.2288 92.41 65.7188C92.7297 65.2088 92.5756 64.5362 92.0656 64.2168C91.5556 63.8968 90.8829 64.0509 90.5632 64.5609Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1637 64.3807C94.5664 64.633 95.0972 64.5113 95.3496 64.1086C95.602 63.706 95.4802 63.1751 95.0775 62.9227C94.6749 62.6704 94.144 62.7922 93.8916 63.1948C93.6393 63.5975 93.7611 64.1283 94.1637 64.3807Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5435 59.8385C93.7862 59.9906 94.1065 59.9173 94.2586 59.6744C94.4106 59.4317 94.3374 59.1115 94.0947 58.9594C93.8521 58.8073 93.5318 58.8806 93.3797 59.1232C93.2274 59.3662 93.3009 59.6865 93.5435 59.8385Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2285 57.8734C86.8273 57.9337 87.3617 57.4973 87.422 56.8984C87.4823 56.2996 87.0458 55.7652 86.447 55.7049C85.8482 55.6446 85.3138 56.0811 85.2535 56.6799C85.1929 57.279 85.6297 57.8131 86.2285 57.8734Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0171 65.1537C80.4897 65.2014 80.9118 64.8567 80.9594 64.384C81.0071 63.9114 80.6624 63.4893 80.1897 63.4417C79.7171 63.394 79.295 63.7387 79.2474 64.2114C79.1997 64.6843 79.5444 65.1061 80.0171 65.1537Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0135 65.404C88.2985 65.4328 88.5529 65.2249 88.5815 64.9399C88.6103 64.6549 88.4023 64.4005 88.1173 64.3719C87.8323 64.3431 87.5779 64.551 87.5494 64.836C87.5206 65.1208 87.7285 65.3752 88.0135 65.404Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0422 61.0705C90.4819 61.0031 90.7836 60.5923 90.7166 60.1529C90.6492 59.7131 90.2383 59.4114 89.7989 59.4784C89.3592 59.5458 89.0575 59.9567 89.1245 60.3961C89.1919 60.8361 89.6028 61.1379 90.0422 61.0705Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9811 63.2481C89.3282 63.1949 89.5664 62.8708 89.5135 62.5237C89.4606 62.1767 89.1361 61.9384 88.7891 61.9914C88.442 62.0443 88.2038 62.3687 88.2567 62.7158C88.3097 63.0628 88.6341 63.3011 88.9811 63.2481Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6485 62.1937C91.4394 62.2257 91.2956 62.4213 91.3277 62.6304C91.3597 62.8396 91.5553 62.9834 91.7644 62.9513C91.9735 62.9193 92.1174 62.7237 92.0853 62.5146C92.0532 62.3054 91.8577 62.1616 91.6485 62.1937Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1796 66.3151C69.8599 66.8251 70.014 67.4978 70.524 67.8175C71.034 68.1372 71.7066 67.9831 72.026 67.4731C72.3457 66.9631 72.1916 66.2904 71.6816 65.9707C71.1716 65.6507 70.4993 65.8051 70.1796 66.3151Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1179 57.3475C76.5205 57.5998 77.0514 57.4781 77.3038 57.0754C77.5561 56.6728 77.4343 56.1419 77.0317 55.8895C76.629 55.6372 76.0982 55.759 75.8458 56.1616C75.5935 56.564 75.7152 57.0948 76.1179 57.3475Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1333 62.1666C77.3759 62.3187 77.6962 62.2455 77.8483 62.0025C78.0003 61.7599 77.9271 61.4396 77.6842 61.2875C77.4415 61.1355 77.1212 61.2087 76.9692 61.4513C76.8174 61.6943 76.8906 62.0146 77.1333 62.1666Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3655 64.4207C64.9644 64.481 65.4988 64.0445 65.5591 63.4457C65.6194 62.8469 65.1829 62.3124 64.5841 62.2521C63.9852 62.1919 63.4508 62.6283 63.3905 63.2271C63.3299 63.826 63.7667 64.3604 64.3655 64.4207Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3805 65.8801C64.3329 66.3527 64.6776 66.7748 65.1502 66.8221C65.6229 66.8698 66.0449 66.5251 66.0923 66.0524C66.1399 65.5798 65.7952 65.1577 65.3226 65.1101C64.8499 65.0627 64.4282 65.4074 64.3805 65.8801Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6295 67.1581C67.9145 67.187 68.1689 66.979 68.1975 66.694C68.2263 66.409 68.0184 66.1546 67.7334 66.1261C67.4484 66.0973 67.1939 66.3052 67.1654 66.5902C67.1366 66.8752 67.3445 67.1296 67.6295 67.1581Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.859 59.9885C73.2988 59.9211 73.6005 59.5102 73.5335 59.0708C73.4661 58.6311 73.0552 58.3294 72.6158 58.3964C72.1761 58.4638 71.8743 58.8746 71.9414 59.3141C72.0085 59.7538 72.4193 60.0558 72.859 59.9885Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5972 65.0027C68.9442 64.9494 69.1825 64.6253 69.1295 64.2782C69.0766 63.9312 68.7522 63.6929 68.4051 63.7459C68.058 63.7991 67.8198 64.1232 67.8727 64.4703C67.9257 64.8174 68.2501 65.0556 68.5972 65.0027Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2653 63.9482C71.0561 63.9803 70.9123 64.1758 70.9444 64.385C70.9764 64.5944 71.172 64.7379 71.3811 64.7058C71.5903 64.6738 71.7341 64.4782 71.702 64.2691C71.67 64.06 71.4744 63.9161 71.2653 63.9482Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.744 116.234C28.6587 116.83 29.0725 117.382 29.6684 117.467C30.2643 117.552 30.8164 117.139 30.9017 116.543C30.987 115.947 30.5731 115.395 29.9773 115.309C29.3814 115.224 28.8293 115.638 28.744 116.234Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9618 114.609C32.4321 114.676 32.868 114.349 32.9353 113.879C33.0027 113.409 32.6759 112.973 32.2056 112.906C31.7353 112.838 31.2994 113.165 31.2321 113.635C31.1647 114.105 31.4915 114.541 31.9618 114.609Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5528 110.709C29.8363 110.749 30.0992 110.552 30.1398 110.269C30.1804 109.985 29.9834 109.722 29.6998 109.681C29.4163 109.641 29.1534 109.838 29.1128 110.121C29.0725 110.405 29.2692 110.668 29.5528 110.709Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0698 111.88C22.6416 111.692 22.9531 111.077 22.7651 110.505C22.5772 109.933 21.9616 109.621 21.3895 109.809C20.8178 109.997 20.5063 110.613 20.6943 111.185C20.8822 111.757 21.4978 112.068 22.0698 111.88Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.346 121.054C19.7975 120.906 20.0431 120.42 19.8949 119.969C19.7466 119.517 19.2604 119.272 18.809 119.42C18.3575 119.568 18.1119 120.054 18.2601 120.506C18.4084 120.957 18.8946 121.203 19.346 121.054Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7553 118.039C27.0273 117.95 27.1756 117.656 27.0862 117.384C26.9967 117.112 26.7035 116.964 26.4315 117.054C26.1594 117.143 26.0112 117.436 26.1006 117.708C26.19 117.98 26.4832 118.129 26.7553 118.039Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8515 113.255C27.226 113.016 27.3354 112.517 27.0954 112.143C26.8557 111.769 26.3574 111.659 25.983 111.899C25.6086 112.139 25.4992 112.637 25.7392 113.011C25.9792 113.386 26.4771 113.495 26.8515 113.255Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7651 115.676C27.0606 115.487 27.1471 115.094 26.9577 114.798C26.7683 114.502 26.3751 114.416 26.0795 114.605C25.7839 114.795 25.6974 115.188 25.8868 115.484C26.0762 115.779 26.4695 115.865 26.7651 115.676Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7758 113.63C28.5975 113.744 28.5455 113.981 28.6596 114.159C28.7737 114.338 29.0108 114.39 29.189 114.276C29.3672 114.161 29.4193 113.924 29.3052 113.746C29.1914 113.568 28.9543 113.516 28.7758 113.63Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.825 126.107C10.7397 126.703 11.1535 127.255 11.7494 127.34C12.3453 127.426 12.8974 127.012 12.9827 126.416C13.068 125.82 12.6541 125.268 12.0582 125.183C11.4627 125.097 10.9106 125.511 10.825 126.107Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6142 115.501C13.0845 115.569 13.5204 115.242 13.5877 114.772C13.6551 114.301 13.3283 113.866 12.858 113.798C12.3877 113.731 11.9519 114.058 11.8845 114.528C11.8171 114.998 12.1439 115.434 12.6142 115.501Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.498 119.494C15.7815 119.535 16.0445 119.338 16.0851 119.054C16.1256 118.77 15.9286 118.508 15.6451 118.467C15.3615 118.426 15.0986 118.623 15.058 118.907C15.0174 119.191 15.2145 119.453 15.498 119.494Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.74245 126.734C5.31421 126.546 5.62539 125.931 5.43774 125.359C5.2498 124.787 4.63421 124.476 4.06215 124.664C3.49039 124.851 3.17892 125.467 3.36686 126.039C3.5548 126.611 4.17068 126.922 4.74245 126.734Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34883 128.062C5.49706 128.514 5.98324 128.759 6.43471 128.611C6.88618 128.463 7.13177 127.977 6.98354 127.525C6.8353 127.074 6.34912 126.828 5.89765 126.976C5.44648 127.125 5.20059 127.611 5.34883 128.062Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83657 127.912C9.10863 127.823 9.25687 127.53 9.16745 127.258C9.07804 126.986 8.78481 126.837 8.51275 126.927C8.24069 127.016 8.09246 127.309 8.18187 127.582C8.27128 127.854 8.56451 128.002 8.83657 127.912Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7076 119.237C11.082 118.998 11.1914 118.499 10.9514 118.125C10.7117 117.751 10.2135 117.641 9.83907 117.881C9.46466 118.121 9.35524 118.619 9.59524 118.994C9.83495 119.368 10.3332 119.477 10.7076 119.237Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84636 125.549C9.14195 125.36 9.22842 124.967 9.03901 124.671C8.84959 124.375 8.45636 124.289 8.16077 124.478C7.86518 124.668 7.77871 125.061 7.96812 125.356C8.15754 125.652 8.55077 125.739 8.84636 125.549Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8571 123.503C10.6788 123.617 10.6268 123.854 10.7409 124.033C10.855 124.211 11.0921 124.263 11.2703 124.149C11.4485 124.035 11.5006 123.798 11.3865 123.619C11.2724 123.441 11.0353 123.389 10.8571 123.503Z",
    fill: "#FFEAA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4744 65.1523C68.2041 65.1523 71.2276 63.022 71.2276 60.3941C71.2276 57.7662 68.2041 55.6359 64.4744 55.6359C60.7447 55.6359 57.7212 57.7662 57.7212 60.3941C57.7212 63.022 60.7447 65.1523 64.4744 65.1523Z",
    fill: "url(#paint8_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7575 58.5977C64.3534 58.5977 64.8366 58.1146 64.8366 57.5186C64.8366 56.9226 64.3534 56.4395 63.7575 56.4395C63.1615 56.4395 62.6783 56.9226 62.6783 57.5186C62.6783 58.1146 63.1615 58.5977 63.7575 58.5977Z",
    fill: "url(#paint9_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7541 61.1606C62.2246 61.1606 62.6059 60.7792 62.6059 60.3088C62.6059 59.8384 62.2246 59.457 61.7541 59.457C61.2837 59.457 60.9024 59.8384 60.9024 60.3088C60.9024 60.7792 61.2837 61.1606 61.7541 61.1606Z",
    fill: "url(#paint10_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.467 61.5371C65.7506 61.5371 65.9805 61.3072 65.9805 61.0235C65.9805 60.7399 65.7506 60.51 65.467 60.51C65.1834 60.51 64.9535 60.7399 64.9535 61.0235C64.9535 61.3072 65.1834 61.5371 65.467 61.5371Z",
    fill: "url(#paint11_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5061 89.3782C40.2358 89.3782 43.2593 87.2478 43.2593 84.6199C43.2593 81.992 40.2358 79.8617 36.5061 79.8617C32.7764 79.8617 29.7529 81.992 29.7529 84.6199C29.7529 87.2478 32.7764 89.3782 36.5061 89.3782Z",
    fill: "url(#paint12_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7895 82.8235C36.3855 82.8235 36.8686 82.3404 36.8686 81.7444C36.8686 81.1484 36.3855 80.6653 35.7895 80.6653C35.1935 80.6653 34.7104 81.1484 34.7104 81.7444C34.7104 82.3404 35.1935 82.8235 35.7895 82.8235Z",
    fill: "url(#paint13_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7858 85.3864C34.2562 85.3864 34.6376 85.005 34.6376 84.5346C34.6376 84.0642 34.2562 83.6829 33.7858 83.6829C33.3154 83.6829 32.9341 84.0642 32.9341 84.5346C32.9341 85.005 33.3154 85.3864 33.7858 85.3864Z",
    fill: "url(#paint14_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.499 85.7629C37.7826 85.7629 38.0125 85.533 38.0125 85.2494C38.0125 84.9658 37.7826 84.7358 37.499 84.7358C37.2154 84.7358 36.9855 84.9658 36.9855 85.2494C36.9855 85.533 37.2154 85.7629 37.499 85.7629Z",
    fill: "url(#paint15_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3229 96.3443C75.0526 96.3443 78.0761 94.214 78.0761 91.5861C78.0761 88.9582 75.0526 86.8279 71.3229 86.8279C67.5932 86.8279 64.5696 88.9582 64.5696 91.5861C64.5696 94.214 67.5932 96.3443 71.3229 96.3443Z",
    fill: "url(#paint16_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6062 89.7897C71.2022 89.7897 71.6854 89.3066 71.6854 88.7106C71.6854 88.1146 71.2022 87.6315 70.6062 87.6315C70.0103 87.6315 69.5271 88.1146 69.5271 88.7106C69.5271 89.3066 70.0103 89.7897 70.6062 89.7897Z",
    fill: "url(#paint17_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6026 92.3526C69.073 92.3526 69.4544 91.9712 69.4544 91.5008C69.4544 91.0304 69.073 90.649 68.6026 90.649C68.1322 90.649 67.7508 91.0304 67.7508 91.5008C67.7508 91.9712 68.1322 92.3526 68.6026 92.3526Z",
    fill: "url(#paint18_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3155 92.7291C72.5991 92.7291 72.829 92.4992 72.829 92.2156C72.829 91.9319 72.5991 91.702 72.3155 91.702C72.0319 91.702 71.8019 91.9319 71.8019 92.2156C71.8019 92.4992 72.0319 92.7291 72.3155 92.7291Z",
    fill: "url(#paint19_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.126 80.5931C124.856 80.5931 127.88 78.4628 127.88 75.8349C127.88 73.207 124.856 71.0767 121.126 71.0767C117.397 71.0767 114.373 73.207 114.373 75.8349C114.373 78.4628 117.397 80.5931 121.126 80.5931Z",
    fill: "url(#paint20_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.41 74.0387C121.005 74.0387 121.489 73.5556 121.489 72.9596C121.489 72.3636 121.005 71.8805 120.41 71.8805C119.814 71.8805 119.33 72.3636 119.33 72.9596C119.33 73.5556 119.814 74.0387 120.41 74.0387Z",
    fill: "url(#paint21_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.406 76.6016C118.877 76.6016 119.258 76.2202 119.258 75.7498C119.258 75.2794 118.877 74.8981 118.406 74.8981C117.936 74.8981 117.554 75.2794 117.554 75.7498C117.554 76.2202 117.936 76.6016 118.406 76.6016Z",
    fill: "url(#paint22_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.119 76.9781C122.403 76.9781 122.633 76.7482 122.633 76.4646C122.633 76.181 122.403 75.951 122.119 75.951C121.835 75.951 121.605 76.181 121.605 76.4646C121.605 76.7482 121.835 76.9781 122.119 76.9781Z",
    fill: "url(#paint23_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8368 36.8555C68.5665 36.8555 71.59 34.7251 71.59 32.0972C71.59 29.4693 68.5665 27.339 64.8368 27.339C61.1071 27.339 58.0836 29.4693 58.0836 32.0972C58.0836 34.7251 61.1071 36.8555 64.8368 36.8555Z",
    fill: "url(#paint24_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1202 30.3008C64.7162 30.3008 65.1993 29.8177 65.1993 29.2217C65.1993 28.6257 64.7162 28.1426 64.1202 28.1426C63.5242 28.1426 63.0411 28.6257 63.0411 29.2217C63.0411 29.8177 63.5242 30.3008 64.1202 30.3008Z",
    fill: "url(#paint25_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1165 32.8637C62.5869 32.8637 62.9683 32.4823 62.9683 32.0119C62.9683 31.5415 62.5869 31.1602 62.1165 31.1602C61.6461 31.1602 61.2648 31.5415 61.2648 32.0119C61.2648 32.4823 61.6461 32.8637 62.1165 32.8637Z",
    fill: "url(#paint26_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8294 33.2402C66.113 33.2402 66.3429 33.0103 66.3429 32.7267C66.3429 32.4431 66.113 32.2131 65.8294 32.2131C65.5458 32.2131 65.3159 32.4431 65.3159 32.7267C65.3159 33.0103 65.5458 33.2402 65.8294 33.2402Z",
    fill: "url(#paint27_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.052 37.5131C68.562 32.619 58.0394 32.619 51.5494 37.5131C45.0594 42.4072 45.0594 50.3422 51.5494 55.2364C58.0394 60.1305 68.562 60.1305 75.052 55.2364C81.542 50.3422 81.542 42.4072 75.052 37.5131ZM55.8382 49.5611C51.7173 46.8466 51.7173 42.4446 55.8382 39.7305C59.9591 37.0161 66.6406 37.0172 70.7614 39.7316C74.8823 42.4461 74.8838 46.8469 70.7632 49.5611C66.642 52.2755 59.9588 52.2755 55.8382 49.5611Z",
    fill: "url(#paint28_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5253 52.4713C58.9233 56.3951 67.6777 56.3951 73.0754 52.4713C78.4748 48.5463 78.4733 42.1839 73.0754 38.2604C67.6759 34.3354 58.9248 34.3354 53.5253 38.2604C48.1274 42.1839 48.1256 48.5463 53.5253 52.4713ZM70.7627 39.7304C74.8836 42.4448 74.8836 46.8469 70.7627 49.561C66.6418 52.2754 59.9604 52.2742 55.8395 49.5598C51.7186 46.8454 51.7171 42.4445 55.8377 39.7304C59.9589 37.0163 66.6418 37.0163 70.7627 39.7304Z",
    fill: "url(#paint29_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88546 113.155C12.3166 114.093 15.4169 113.398 16.8105 111.601C17.0846 111.248 16.9631 110.832 16.5813 110.407C16.1593 109.936 16.3108 109.315 16.8902 108.937L16.9881 108.873C17.7366 108.383 17.5652 107.519 16.6543 107.193L13.0293 105.894C12.1184 105.567 11.0234 105.977 10.9002 106.691C10.8052 107.241 10.1652 107.667 9.37869 107.699C8.74957 107.724 8.25751 107.878 8.00663 108.202C6.61281 109.999 7.45428 112.216 9.88546 113.155Z",
    fill: "url(#paint30_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2253 94.3358C28.6856 90.1584 19.7042 90.1584 14.1645 94.3358C8.62475 98.5131 8.62475 105.286 14.1645 109.463C19.7042 113.641 28.6856 113.641 34.2253 109.463C39.7647 105.286 39.7647 98.5131 34.2253 94.3358ZM17.825 104.619C14.3077 102.303 14.3077 98.5452 17.825 96.2284C21.3424 93.9117 27.0453 93.9125 30.5627 96.2293C34.08 98.5461 34.0815 102.303 30.5642 104.619C27.0471 106.936 21.3424 106.936 17.825 104.619Z",
    fill: "url(#paint31_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8511 107.103C20.4585 110.452 27.9308 110.452 32.5382 107.103C37.147 103.753 37.1455 98.3223 32.5382 94.9732C27.9294 91.6232 20.4599 91.6232 15.8511 94.9732C11.2438 98.3226 11.2423 103.753 15.8511 107.103ZM30.5644 96.2282C34.0817 98.545 34.0817 102.302 30.5644 104.619C27.047 106.936 21.3441 106.935 17.8267 104.618C14.3094 102.301 14.3079 98.545 17.8252 96.2282C21.3423 93.9114 27.047 93.9114 30.5644 96.2282Z",
    fill: "url(#paint32_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.417 79.345C97.9854 78.4065 94.8851 79.1021 93.4915 80.8985C93.2174 81.2521 93.3389 81.6674 93.7207 82.0929C94.1427 82.5635 93.9912 83.1844 93.4118 83.5632L93.3139 83.6271C92.5654 84.1165 92.7368 84.9806 93.6477 85.3071L97.2727 86.6062C98.1836 86.9327 99.2786 86.5227 99.4018 85.8091C99.4968 85.2591 100.137 84.8332 100.923 84.8012C101.552 84.7756 102.044 84.6215 102.295 84.2979C103.689 82.5009 102.848 80.2835 100.417 79.345Z",
    fill: "url(#paint33_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0211 80.3474C103.103 80.3474 108.843 76.3026 108.843 71.313C108.843 66.3234 103.103 62.2786 96.0211 62.2786C88.9395 62.2786 83.1987 66.3234 83.1987 71.313C83.1987 76.3026 88.9395 80.3474 96.0211 80.3474Z",
    fill: "url(#paint34_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6603 67.902C95.7917 67.902 96.7089 66.9848 96.7089 65.8535C96.7089 64.7221 95.7917 63.8049 94.6603 63.8049C93.529 63.8049 92.6118 64.7221 92.6118 65.8535C92.6118 66.9848 93.529 67.902 94.6603 67.902Z",
    fill: "url(#paint35_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8563 72.7684C91.7495 72.7684 92.4737 72.0443 92.4737 71.151C92.4737 70.2578 91.7495 69.5337 90.8563 69.5337C89.9631 69.5337 89.239 70.2578 89.239 71.151C89.239 72.0443 89.9631 72.7684 90.8563 72.7684Z",
    fill: "url(#paint36_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9058 73.4831C98.4443 73.4831 98.8808 73.0466 98.8808 72.5081C98.8808 71.9696 98.4443 71.5331 97.9058 71.5331C97.3674 71.5331 96.9308 71.9696 96.9308 72.5081C96.9308 73.0466 97.3674 73.4831 97.9058 73.4831Z",
    fill: "url(#paint37_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9275 104.192C49.0091 104.192 54.7498 100.147 54.7498 95.1577C54.7498 90.1681 49.0091 86.1233 41.9275 86.1233C34.8459 86.1233 29.1051 90.1681 29.1051 95.1577C29.1051 100.147 34.8459 104.192 41.9275 104.192Z",
    fill: "url(#paint38_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5667 91.7467C41.6981 91.7467 42.6152 90.8296 42.6152 89.6982C42.6152 88.5668 41.6981 87.6497 40.5667 87.6497C39.4353 87.6497 38.5182 88.5668 38.5182 89.6982C38.5182 90.8296 39.4353 91.7467 40.5667 91.7467Z",
    fill: "url(#paint39_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.763 96.6131C37.6562 96.6131 38.3804 95.889 38.3804 94.9958C38.3804 94.1025 37.6562 93.3784 36.763 93.3784C35.8698 93.3784 35.1457 94.1025 35.1457 94.9958C35.1457 95.889 35.8698 96.6131 36.763 96.6131Z",
    fill: "url(#paint40_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8125 97.3279C44.351 97.3279 44.7875 96.8914 44.7875 96.3529C44.7875 95.8145 44.351 95.3779 43.8125 95.3779C43.274 95.3779 42.8375 95.8145 42.8375 96.3529C42.8375 96.8914 43.274 97.3279 43.8125 97.3279Z",
    fill: "url(#paint41_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2449 67.8343C66.8137 66.8957 63.7134 67.5913 62.3199 69.3878C62.0458 69.7413 62.1673 70.1566 62.549 70.5822C62.9711 71.0528 62.8196 71.6737 62.2402 72.0525L62.1423 72.1163C61.3937 72.6057 61.5652 73.4699 62.4761 73.7963L66.1011 75.0954C67.012 75.4219 68.107 75.0119 68.2302 74.2984C68.3252 73.7484 68.9652 73.3225 69.7517 73.2904C70.3808 73.2649 70.8728 73.1107 71.1237 72.7872C72.5173 70.9904 71.6761 68.7731 69.2449 67.8343Z",
    fill: "url(#paint42_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8791 96.2122C75.8574 95.7164 78.0765 93.8358 78.0765 91.5858C78.0765 88.9578 75.0529 86.8275 71.3232 86.8275C68.9503 86.8275 66.8674 87.6916 65.6627 88.9958L72.8791 96.2122Z",
    fill: "url(#paint43_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1306 73.1181C79.5908 68.9408 70.6094 68.9408 65.0697 73.1181C59.53 77.2955 59.53 84.0684 65.0697 88.2458C70.6094 92.4231 79.5908 92.4231 85.1306 88.2458C90.6703 84.0684 90.6703 77.2955 85.1306 73.1181ZM68.7306 83.4017C65.2132 81.0849 65.2132 77.3275 68.7306 75.0108C72.2479 72.694 77.9508 72.6949 81.4682 75.0117C84.9856 77.3284 84.987 81.0849 81.4697 83.4017C77.9523 85.7184 72.2479 85.7184 68.7306 83.4017Z",
    fill: "url(#paint44_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7566 85.8856C71.364 89.2347 78.8363 89.2347 83.4437 85.8856C88.0525 82.5355 88.051 77.1047 83.4437 73.7555C78.8349 70.4055 71.3655 70.4055 66.7566 73.7555C62.1493 77.105 62.1478 82.5355 66.7566 85.8856ZM81.4696 75.0108C84.9869 77.3276 84.9869 81.085 81.4696 83.4017C77.9522 85.7185 72.2493 85.7176 68.7319 83.4008C65.2146 81.0841 65.2131 77.3276 68.7305 75.0108C72.2478 72.6938 77.9522 72.6938 81.4696 75.0108Z",
    fill: "url(#paint45_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8718 81.9547C19.6394 81.9547 17.0191 83.8209 17.0191 86.1232C17.0191 88.4256 19.6394 90.2918 22.8718 90.2918C26.1041 90.2918 28.7244 88.4256 28.7244 86.1232C28.7244 83.8209 26.1041 81.9547 22.8718 81.9547ZM22.8718 87.8927C21.4997 87.8927 20.3876 87.1006 20.3876 86.1232C20.3876 85.1462 21.4997 84.3538 22.8718 84.3538C24.2438 84.3538 25.3559 85.1459 25.3559 86.1232C25.3562 87.1006 24.2438 87.8927 22.8718 87.8927Z",
    fill: "url(#paint46_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5347 73.8302C49.3024 73.8302 46.6821 75.6964 46.6821 77.9987C46.6821 80.3011 49.3024 82.1673 52.5347 82.1673C55.7671 82.1673 58.3874 80.3011 58.3874 77.9987C58.3874 75.6964 55.7668 73.8302 52.5347 73.8302ZM52.5347 79.7679C51.1627 79.7679 50.0506 78.9758 50.0506 77.9984C50.0506 77.0214 51.1627 76.229 52.5347 76.229C53.9068 76.229 55.0188 77.0211 55.0188 77.9984C55.0188 78.9758 53.9065 79.7679 52.5347 79.7679Z",
    fill: "url(#paint47_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3101 52.8546C87.0778 52.8546 84.4575 54.7208 84.4575 57.0231C84.4575 59.3255 87.0778 61.1917 90.3101 61.1917C93.5425 61.1917 96.1628 59.3255 96.1628 57.0231C96.1628 54.7208 93.5425 52.8546 90.3101 52.8546ZM90.3101 58.7926C88.9381 58.7926 87.826 58.0005 87.826 57.0231C87.826 56.0458 88.9381 55.2537 90.3101 55.2537C91.6822 55.2537 92.7942 56.0458 92.7942 57.0231C92.7942 58.0005 91.6822 58.7926 90.3101 58.7926Z",
    fill: "url(#paint48_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2936 114.34C8.06124 114.34 5.44095 116.206 5.44095 118.509C5.44095 120.811 8.06124 122.677 11.2936 122.677C14.526 122.677 17.1462 120.811 17.1462 118.509C17.1462 116.206 14.526 114.34 11.2936 114.34ZM11.2936 120.278C9.92154 120.278 8.80948 119.486 8.80948 118.508C8.80948 117.531 9.92154 116.739 11.2936 116.739C12.6657 116.739 13.7777 117.531 13.7777 118.508C13.7777 119.486 12.6657 120.278 11.2936 120.278Z",
    fill: "url(#paint49_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2884 72.8392C50.37 72.8392 56.1108 68.7944 56.1108 63.8048C56.1108 58.8152 50.37 54.7704 43.2884 54.7704C36.2068 54.7704 30.4661 58.8152 30.4661 63.8048C30.4661 68.7944 36.2068 72.8392 43.2884 72.8392Z",
    fill: "url(#paint50_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9277 60.3938C43.059 60.3938 43.9762 59.4767 43.9762 58.3453C43.9762 57.2139 43.059 56.2968 41.9277 56.2968C40.7963 56.2968 39.8791 57.2139 39.8791 58.3453C39.8791 59.4767 40.7963 60.3938 41.9277 60.3938Z",
    fill: "url(#paint51_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1236 65.2602C39.0169 65.2602 39.741 64.5361 39.741 63.6429C39.741 62.7496 39.0169 62.0255 38.1236 62.0255C37.2304 62.0255 36.5063 62.7496 36.5063 63.6429C36.5063 64.5361 37.2304 65.2602 38.1236 65.2602Z",
    fill: "url(#paint52_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1731 65.9749C45.7116 65.9749 46.1481 65.5384 46.1481 64.9999C46.1481 64.4614 45.7116 64.0249 45.1731 64.0249C44.6346 64.0249 44.1981 64.4614 44.1981 64.9999C44.1981 65.5384 44.6346 65.9749 45.1731 65.9749Z",
    fill: "url(#paint53_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8484 40.5649C86.4172 39.6263 83.3169 40.3219 81.9234 42.1184C81.6493 42.4719 81.7707 42.8872 82.1525 43.3128C82.5746 43.7834 82.4231 44.4043 81.8437 44.7831L81.7457 44.8469C80.9972 45.3363 81.1687 46.2004 82.0796 46.5269L85.7046 47.826C86.6154 48.1525 87.7105 47.7425 87.8337 47.029C87.9287 46.479 88.5687 46.0531 89.3552 46.021C89.9843 45.9954 90.4763 45.8413 90.7272 45.5178C92.1207 43.7207 91.2796 41.5034 88.8484 40.5649Z",
    fill: "url(#paint54_linear_465_7322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6653 30.6835C74.6659 34.8656 85.0691 41.0735 98.3956 50.8621C111.722 60.6506 121.974 75.3059 129.581 84.7915C133.667 89.8868 144.918 88.9606 148.633 83.1553C151.114 79.2785 151.121 71.4462 148.593 67.8606C141.134 57.2812 128.572 44.8529 113.056 33.4562C97.5406 22.0594 82.1914 13.9871 70.2917 10.3468C66.2588 9.11294 61.8361 10.9232 59.3553 14.8C55.6403 20.6056 57.7561 28.4371 63.6653 30.6835Z",
    fill: "url(#paint55_linear_465_7322)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_465_7322",
    x1: 66.1839,
    y1: 87.905,
    x2: 74.0986,
    y2: 105.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_465_7322",
    x1: 74.463,
    y1: 106.407,
    x2: 67.7824,
    y2: 87.0841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_465_7322",
    x1: 43.1578,
    y1: 65.0515,
    x2: 78.4057,
    y2: 107.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_465_7322",
    x1: 91.9567,
    y1: 62.7385,
    x2: 104.462,
    y2: 45.0088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_465_7322",
    x1: 86.1528,
    y1: 69.7311,
    x2: 29.7981,
    y2: -17.4393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_465_7322",
    x1: 57.312,
    y1: 76.0707,
    x2: 33.5673,
    y2: 31.5886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_465_7322",
    x1: 95.0414,
    y1: 88.5638,
    x2: 71.402,
    y2: 44.0288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_465_7322",
    x1: 42.7587,
    y1: 112.912,
    x2: 23.7628,
    y2: 80.6189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_465_7322",
    x1: 63.0329,
    y1: 56.9012,
    x2: 65.9232,
    y2: 63.9047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_465_7322",
    x1: 64.3886,
    y1: 59.3576,
    x2: 61.6317,
    y2: 55.0554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_465_7322",
    x1: 62.1978,
    y1: 61.8581,
    x2: 60.0212,
    y2: 58.4617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_465_7322",
    x1: 65.6346,
    y1: 62.139,
    x2: 64.3227,
    y2: 60.0914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_465_7322",
    x1: 35.0646,
    y1: 81.127,
    x2: 37.9549,
    y2: 88.1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_465_7322",
    x1: 36.4088,
    y1: 83.599,
    x2: 33.652,
    y2: 79.2968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_465_7322",
    x1: 34.2177,
    y1: 86.0995,
    x2: 32.0414,
    y2: 82.7031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_465_7322",
    x1: 37.6548,
    y1: 86.3804,
    x2: 36.3426,
    y2: 84.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_465_7322",
    x1: 69.8814,
    y1: 88.0932,
    x2: 72.7717,
    y2: 95.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_465_7322",
    x1: 71.2442,
    y1: 90.5651,
    x2: 68.4874,
    y2: 86.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_465_7322",
    x1: 69.0532,
    y1: 93.0652,
    x2: 66.8769,
    y2: 89.6691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_465_7322",
    x1: 72.4902,
    y1: 93.3465,
    x2: 71.178,
    y2: 91.2987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_465_7322",
    x1: 119.685,
    y1: 72.3422,
    x2: 122.575,
    y2: 79.3455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_465_7322",
    x1: 121.072,
    y1: 74.8001,
    x2: 118.314,
    y2: 70.4979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_465_7322",
    x1: 118.881,
    y1: 77.3006,
    x2: 116.704,
    y2: 73.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_465_7322",
    x1: 122.318,
    y1: 77.5816,
    x2: 121.005,
    y2: 75.5339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_465_7322",
    x1: 63.3953,
    y1: 28.6043,
    x2: 66.2856,
    y2: 35.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2269,
    stopColor: "#B0CE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    stopColor: "#95AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_465_7322",
    x1: 64.7482,
    y1: 31.0461,
    x2: 61.9913,
    y2: 26.7439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_465_7322",
    x1: 62.5574,
    y1: 33.5466,
    x2: 60.3808,
    y2: 30.1502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_465_7322",
    x1: 65.9944,
    y1: 33.8276,
    x2: 64.6822,
    y2: 31.7801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_465_7322",
    x1: 67.1209,
    y1: 35.115,
    x2: 61.9344,
    y2: 50.2506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_465_7322",
    x1: 60.2857,
    y1: 54.3639,
    x2: 64.4714,
    y2: 42.1488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_465_7322",
    x1: 11.5363,
    y1: 107.95,
    x2: 16.2852,
    y2: 115.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_465_7322",
    x1: 27.458,
    y1: 92.2741,
    x2: 23.0311,
    y2: 105.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_465_7322",
    x1: 21.6402,
    y1: 108.702,
    x2: 25.2129,
    y2: 98.2758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_465_7322",
    x1: 96.3209,
    y1: 80.5171,
    x2: 102.612,
    y2: 90.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_465_7322",
    x1: 93.284,
    y1: 64.6812,
    x2: 98.772,
    y2: 77.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_465_7322",
    x1: 96.1052,
    y1: 68.9369,
    x2: 90.8705,
    y2: 60.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_465_7322",
    x1: 91.9452,
    y1: 73.6843,
    x2: 87.8129,
    y2: 67.2357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_465_7322",
    x1: 98.4706,
    y1: 74.2178,
    x2: 95.9795,
    y2: 70.3301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_465_7322",
    x1: 39.1907,
    y1: 88.5259,
    x2: 44.6784,
    y2: 101.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_465_7322",
    x1: 41.9865,
    y1: 92.7996,
    x2: 36.7521,
    y2: 84.6311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_465_7322",
    x1: 37.8265,
    y1: 97.5474,
    x2: 33.6942,
    y2: 91.0988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_465_7322",
    x1: 44.3523,
    y1: 98.0807,
    x2: 41.8608,
    y2: 94.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_465_7322",
    x1: 65.149,
    y1: 69.0063,
    x2: 71.4405,
    y2: 79.4543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_465_7322",
    x1: 76.4497,
    y1: 98.5205,
    x2: 63.8912,
    y2: 74.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798C00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#556100",
    stopOpacity: 0.654
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#464F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_465_7322",
    x1: 78.3555,
    y1: 71.0597,
    x2: 73.9286,
    y2: 83.9789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_465_7322",
    x1: 72.5379,
    y1: 87.4876,
    x2: 76.1106,
    y2: 77.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#FDC4B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7655,
    stopColor: "#FBAE97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_465_7322",
    x1: 20.4962,
    y1: 81.3721,
    x2: 23.2065,
    y2: 86.7927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_465_7322",
    x1: 50.1591,
    y1: 73.2476,
    x2: 52.8694,
    y2: 78.6681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_465_7322",
    x1: 87.9345,
    y1: 52.272,
    x2: 90.6448,
    y2: 57.6926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_465_7322",
    x1: 8.91801,
    y1: 113.758,
    x2: 11.6283,
    y2: 119.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3344,
    stopColor: "#867385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7039,
    stopColor: "#7B667B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_465_7322",
    x1: 40.5517,
    y1: 57.173,
    x2: 46.0393,
    y2: 70.4704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2243,
    stopColor: "#FE5B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5952,
    stopColor: "#FC4637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_465_7322",
    x1: 43.3446,
    y1: 61.4308,
    x2: 38.1102,
    y2: 53.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_465_7322",
    x1: 39.1846,
    y1: 66.1783,
    x2: 35.0523,
    y2: 59.7297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_465_7322",
    x1: 45.71,
    y1: 66.7117,
    x2: 43.2189,
    y2: 62.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2454,
    stopColor: "#F12817",
    stopOpacity: 0.245
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6052,
    stopColor: "#DD2820",
    stopOpacity: 0.605
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_465_7322",
    x1: 84.7525,
    y1: 41.7366,
    x2: 91.0437,
    y2: 52.1846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A57C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1339,
    stopColor: "#A26C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5155,
    stopColor: "#994336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8174,
    stopColor: "#942A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_465_7322",
    x1: 110.139,
    y1: 38.9326,
    x2: 99.1632,
    y2: 56.8732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2061,
    stopColor: "#FBA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5808,
    stopColor: "#FDA861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA936"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_465_7322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0.491943)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategoryPizza);
export default __webpack_public_path__ + "static/media/icon-category-pizza.7c2ffc6f.svg";
export { ForwardRef as ReactComponent };